import { render, staticRenderFns } from "./monthly_area_brand.vue?vue&type=template&id=0b27cc13&scoped=true"
import script from "./monthly_area_brand.vue?vue&type=script&lang=js"
export * from "./monthly_area_brand.vue?vue&type=script&lang=js"
import style0 from "./monthly_area_brand.vue?vue&type=style&index=0&id=0b27cc13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b27cc13",
  null
  
)

export default component.exports